import React from 'react';
import { FormControl } from '@mui/material';
import { CustomDatePicker, InputProps } from './componentsnew';
import dayjs from 'dayjs';

const InputDateField = ({
  label,
  value,
  onChange,
  variant = 'standard',
  error = false,
  disabled = false,
  fullWidth = true,
  placeholder = 'DD MMM YYYY',
  format = 'DD MMM YYYY',
  inputFormat,
  sx,
  ...props
}) => {
  const parsedValue = value ? (dayjs.isDayjs(value) ? value : dayjs(value).isValid() ? dayjs(value) : null) : null;

  return (
    <FormControl fullWidth={fullWidth} variant={variant} size='small' error={error} disabled={disabled} sx={sx} {...props}>
      <CustomDatePicker
        variant={variant}
        disabled={disabled}
        error={error}
        format={format}
        value={parsedValue}
        onChange={(val) => {
          if (!onChange) return;
          if (val && dayjs.isDayjs(val) && val.isValid()) {
            onChange({ target: { value: val.format(inputFormat || 'DD MMM YYYY') } });
            return;
          }
          onChange({ target: { value: val ? String(val) : '' } });
        }}
        slotProps={{
          textField: {
            ...InputProps,
            fullWidth: true,
            label,
            placeholder,
            variant,
            error,
            disabled,
          },
        }}
      />
    </FormControl>
  );
};

export default InputDateField;
